import type { FontInfo } from '@/hooks/use-load-fonts/typings';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service';

const useLoadFonts = (fonts: FontInfo[]) => {
	const documentFonts = Array.from(document.fonts);

	const fontsCss = fonts.reduce((acc, font) => {
		const fontLoaded = documentFonts.some((fontFace) => {
			return (
				String(fontFace.family) === String(font.name) &&
				String(fontFace.weight) === String(font.weight) &&
				String(fontFace.style) === String(font.style)
			);
		});
		if (!fontLoaded) {
			acc.push(font.css(EnvVarsService.getVar('VITE_FONT_ENDPOINT')));
		}
		return acc;
	}, [] as string[]);

	return fontsCss;
};

export default useLoadFonts;
